export default {
  medicalDevices: [],
  medicalDevice: undefined,
};
